const ProductRoutes = [
  {
    // Product Entry (Onboarding)

    path: '/new-product',
    component: () =>
      import('@/components/inventory/add-product-setup/AddNewProduct.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/new-product',
        // name: 'new-product',
        component: () =>
          import(
            '@/components/inventory/add-product-setup/SetProductCategory.vue'
          ),
      },
      {
        path: '/product-details',
        name: 'product-details',
        component: () =>
          import(
            '@/components/inventory/add-product-setup/InputProductDetails.vue'
          ),
      },
      {
        path: '/product-image',
        // name: 'product-image',
        component: () =>
          import(
            '@/components/inventory/add-product-setup/AddProductImage.vue'
          ),
      },

      {
        path: '/inventory-details',
        name: 'inventory-details',
        component: () =>
          import(
            '@/components/inventory/add-product-setup/AddInventoryDetails.vue'
          ),
      },
    ],
  },
  //Edit new products
  {
    path: '/edit-product',
    name: 'edit-product',
    component: () =>
      import('@/components/inventory/edit-product/EditProduct.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/edit-product',
        // name: 'edit-product',
        component: () =>
          import('@/components/inventory/edit-product/EditProductCategory.vue'),
      },
      {
        path: '/edit-product-details',
        name: 'edit-product-details',
        component: () => import('@/components/inventory/edit-product/EditProductDetails.vue'),
      },
      {
        path: '/edit-product-image',
        name: 'edit-product-image',
        component: () => import('@/components/inventory/edit-product/EditProductImage.vue'),
      },

      {
        path: '/edit-inventory-details',
        name: 'edit-inventory-details',
        component: () => import('@/components/inventory/edit-product/EditInventoryDetails.vue'),
      },
    ],
  },

  //More Products Details
  {
    path: '/catalog-details',
    name: 'catalog--details',
    component: () => import('@/components/inventory/ProductDetails.vue'),
    props: true,
  },
];

export default ProductRoutes;
